export const getBrowserTimeZone = () => {
  try {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (typeof timeZone !== 'string') return undefined;

    const trimmed = timeZone.trim();
    return trimmed || undefined;
  } catch {
    return undefined;
  }
};
